import {gql} from '@apollo/client'

export const GET_PATIENT_LIST_DASHBOARD = gql`
  query getScheduledAppointmentListByDate($date: DateTime!) {
    getScheduledAppointmentListByDate(date: $date) {
      id
      patientId
      firstName
      lastName
      profilePhoto
      appointmentType
      slotStart
      slotEnd
    }
  }
`
export const GET_PROFILE_SETUP_STATUS = gql`
  query getProfileSetupStatus {
    getProfileSetupStatus {
      stepName
      stepNumber
      screenName
      isCompleted
      isVerified
      isOptional
    }
  }
`

export const GET_VISTING_HOURS = gql`
  query getDoctorVisitingHours {
    getDoctorVisitingHours {
      weeklySlotsDetails {
        dayOfWeek
        timings {
          slotStart
          slotEnd
        }
        isClosed
        isOpen24Hours
      }
      monthlySlotsDetails {
        calendarType
        dates
        timings {
          slotStart
          slotEnd
        }
        repeatOption
        repeatRemark
      }
    }
  }
`
export const GET_BUSINESS_STEPS = gql`
  query getProfileSetupStatus {
    getProfileSetupStatus {
      stepName
      stepNumber
      screenName
      isCompleted
      isVerified
      isOptional
    }
  }
`

export const GET_DOCTOR_APPOINTMENT_ON_DATE = gql`
  query getDoctorAppointmentOnDateV2(
    $date: Date!
    $doctorId: ID
    $timeZone: String
    $page: Int!
    $limit: Int!
  ) {
    getDoctorAppointmentOnDateV2(
      date: $date
      doctorId: $doctorId
      timeZone: $timeZone
      listFilter: {page: $page, limit: $limit}
    ) {
      data {
        id
        patientId
        firstName
        lastName
        doctorFirstName
        doctorLastName
        isPrescriptionSent
        appointmentType
        appointmentMode
        appointmentStartTime
        paymentDetail {
          orderId
          paymentStatus
          remainingAmount
          paymentTime
          paymentMethod
          transactionId
          paymentMode
          paymentCurrency
          paymentAmount
          paymentAmountBreakup
        }
        latestStatus
        isWalkInPatient
        followUpDate
        currency
        tokenNumber
        profilePhoto
        dob
      }
      total
      page
      totalPages
      pageSize
    }
  }
`

export const GET_DOCTOR_APPOINTMENT_ON_DATE_BY_STATUS = gql`
  query getDoctorAppointmentOnDateByStatus(
    $date: Date!
    $doctorId: ID!
    $timeZone: String!
    $page: Int!
    $limit: Int!
    $appointmentStatus: APPOINTMENT_STATUS!
  ) {
    getDoctorAppointmentOnDateByStatus(
      date: $date
      timeZone: $timeZone
      doctorId: $doctorId
      listFilter: {page: $page, limit: $limit}
      appointmentStatus: $appointmentStatus
    ) {
      data {
        id
        patientId
        patientRoleId
        firstName
        lastName
        doctorFirstName
        doctorLastName
        isPrescriptionSent
        appointmentType
        appointmentMode
        appointmentStartTime
        latestStatus
        isWalkInPatient
        followUpDate
        currency
        tokenNumber
        dob
        age
        profilePhoto
      }
      total
      pageSize
      page
      totalPages
    }
  }
`

export const GET_CLINIC_APPOINTMENT_ON_DATE_BY_STATUS = gql`
  query getClinicAppointmentsOnDateByStatus(
    $date: Date!
    $timeZone: String!
    $page: Int!
    $limit: Int!
    $appointmentStatus: APPOINTMENT_STATUS!
  ) {
    getClinicAppointmentsOnDateByStatus(
      date: $date
      timeZone: $timeZone
      listFilter: {page: $page, limit: $limit}
      appointmentStatus: $appointmentStatus
    ) {
      data {
        id
        patientId
        patientRoleId
        firstName
        lastName
        doctorFirstName
        doctorLastName
        isPrescriptionSent
        appointmentType
        appointmentMode
        appointmentStartTime
        latestStatus
        isWalkInPatient
        followUpDate
        currency
        tokenNumber
        dob
        age
        profilePhoto
      }
      total
      pageSize
      page
      totalPages
    }
  }
`

export const CANCEL_APPOINTMENT = gql`
  mutation changeDoctorAppointmentStatus($appointmentId: ID!, $status: APPOINTMENT_STATUS!) {
    changeDoctorAppointmentStatus(appointmentId: $appointmentId, status: $status)
  }
`

export const GET_BUSSINESS_OPERATING_HOURS = gql`
  query GetBusinessOperatingHours {
    getBusinessOperatingHours {
      dayOfWeek
      timings {
        openTime
        closeTime
      }
      isClosed
      isOpen24Hours
    }
  }
`
export const GET_CLINIC_APPOINTMENT_INSIGHTS = gql`
  query getClinicAppointmentInsights(
    $clinicDoctorId: ID
    $startDate: DateTime
    $endDate: DateTime
  ) {
    getClinicAppointmentInsights(
      clinicDoctorId: $clinicDoctorId
      startDate: $startDate
      endDate: $endDate
    ) {
      appointmentsInsight {
        bookedAppointmentCount
        completedAppointmentCount
        cancelledAppointmentCount
        __typename
      }
      daignosisInsights {
        id
        timesReported
        __typename
      }
      __typename
    }
  }
`

export const GET_CLINIC_PAYMENT_INSIGHTS = gql`
  query getClinicPaymentInsights($startDate: DateTime, $endDate: DateTime) {
    getClinicPaymentInsights(startDate: $startDate, endDate: $endDate) {
      paymentMode
      paymentAmount
      __typename
    }
  }
`
export const GET_CLINIC_RX_MONTHLY_REPORT = gql`
  query getClinicRXMonthlyReport(
    $year: Int!
    $month: Int!
    $clinicDoctorId: ID
    $timeZone: String
  ) {
    getClinicRXMonthlyReport(
      year: $year
      month: $month
      clinicDoctorId: $clinicDoctorId
      timeZone: $timeZone
    ) {
      weekWiseData {
        day
        date
        rxCount
        appointmentCount
      }
      totalRx
      totalAppointment
      title
    }
  }
`

export const CANCEL_DOCTOR_APPOINTMENTS = gql`
  mutation cancelDoctorAppointments($appointmentIds: [ID!]!, $timeZone: String!) {
    cancelDoctorAppointments(appointmentIds: $appointmentIds, timeZone: $timeZone) {
      summary {
        total
        cancelled
        failed
      }
    }
  }
`
